import { scaleTypeMap } from "../../../../../api/services";

const resolveFactorName = (question, customFactorsMap?: Record<string, string>): string => {
	if (question.factor === "Custom" && customFactorsMap) {
		return (question.custom_factor && customFactorsMap[question.custom_factor]) || "Unassigned";
	}
	return question.factor || "";
};

export const getSorts = (a, b, currentSort, customFactorsMap?: Record<string, string>) => {
	const caseInsensitiveSorts = ["factor", "question", "updated_by_employee.name"];
	const dateSorts = ["created_at", "updated_at"];

	if (currentSort.name === "type") {
		return [scaleTypeMap[a.scale], scaleTypeMap[b.scale]];
	}
	if (currentSort.name === "enabled") {
		const sortA = a.enabled === true ? "enabled" : "disabled";
		const sortB = b.enabled === true ? "enabled" : "disabled";
		return [sortA, sortB];
	}
	if (dateSorts.includes(currentSort.name)) {
		const dateA = a[currentSort.name] ? new Date(a[currentSort.name]) : null;
		const dateB = b[currentSort.name] ? new Date(b[currentSort.name]) : null;

		return [dateA, dateB];
	}
	if (caseInsensitiveSorts.includes(currentSort.name)) {
		// handle specific case for modified by
		if (currentSort.name === "updated_by_employee.name") {
			return [a.updated_by_employee?.name.toLowerCase(), b.updated_by_employee?.name.toLowerCase()];
		}
		// resolve custom factor names for sorting
		if (currentSort.name === "factor" && customFactorsMap) {
			return [
				resolveFactorName(a, customFactorsMap).toLowerCase(),
				resolveFactorName(b, customFactorsMap).toLowerCase(),
			];
		}
		return [a[currentSort.name].toLowerCase(), b[currentSort.name].toLowerCase()];
	}
	return [a[currentSort.name], b[currentSort.name]];
};

export const filterByFactor = (questions, factor) => {
	return questions.filter((question) => {
		// filter out enps question
		if (["eNPS", "Other"].includes(question.factor)) {
			return false;
		}
		if (factor !== "All Factors") {
			return question.factor === factor;
		}
		return true;
	});
};

export const filterBySearchInput = (questions, searchValue) => {
	if (!searchValue) {
		return questions;
	}

	const searchValueLower = searchValue.toLowerCase();

	return questions.filter((question) => {
		const questionLower = question.question.toLowerCase();
		return questionLower.includes(searchValueLower);
	});
};

export const orderQuestions = (questions, currentSort, customFactorsMap?: Record<string, string>) => {
	return questions.sort((a, b) => {
		const [sortA, sortB] = getSorts(a, b, currentSort, customFactorsMap);

		if (sortA < sortB) {
			return currentSort.direction === "asc" ? -1 : 1;
		}

		if (sortA > sortB) {
			return currentSort.direction === "asc" ? 1 : -1;
		}

		//secondary sort on question column
		if (currentSort.name !== "question") {
			if (a.question < b.question) {
				return -1;
			}

			if (a.question > b.question) {
				return 1;
			}

			return 0;
		}
	});
};

export const processQuestions = (
	questions,
	factor,
	currentSort,
	searchValue,
	customFactorsMap?: Record<string, string>
) => {
	// first filter questions by the factor dropdown selection
	const filteredByFactor = filterByFactor(questions, factor);

	// then filter by the search input
	const filteredBySearchAndFactor = filterBySearchInput(filteredByFactor, searchValue);

	// then order by the current sort
	const orderedQuestions = orderQuestions(filteredBySearchAndFactor, currentSort, customFactorsMap);

	return orderedQuestions;
};
